<template>
  <v-app-bar :elevation="3" :class="{'pt-6': isIOS}">
    <v-container fluid >
      <v-row>
        <v-col cols="auto" @click="gotoDashboard()" style="    display: flex;
          align-items: center;
          align-content: center;
          flex-direction: column;
          justify-content: center;">
          <img src="/logo_light.png" alt="Praxis Keilberg Logo"
            style="width: 120px; object-position: left; object-fit: contain"></img>
        </v-col>
        <v-col cols="auto" style="display: flex; align-items: center" v-if="!isMobile">
          <BreadcrumbsVue />
        </v-col>

        <v-spacer />

        <v-col :cols="isMobile ? 5 : 3" v-if="$store.state.staff && $store.state.staff != 'false'"
          style="display: flex; align-items: center">
          <v-select :label="$t('basics.role')" :items="roles" variant="outlined" v-model="role" density="compact"
            class="hideDetails py-0" return-object multiple ref="roleChanger" :close-on-content-click="false">
            <template v-slot:item="{ active, item, attrs }">
              <v-list-item v-bind="attrs" @click="addRole(item)" class="hoverable">
                <v-list-item-title>
                  <v-row no-gutters align="center" class="ml-3">
                    <v-icon v-if="roleIsSelected(item)" class="mr-2">mdi-checkbox-outline</v-icon>
                    <v-icon v-else class="mr-2">mdi-checkbox-blank-outline</v-icon>
                    <span>{{ item.raw.key }} - {{ $t("constants." + item.value.name) }}</span>
                  </v-row>
                </v-list-item-title>
              </v-list-item>
            </template>

            <template v-slot:selection="{ active, item, attrs }">
              <v-chip v-bind="attrs" style="
                  overflow: hidden;
                  font-size: x-small;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                ">
                <span v-if="role.length > 1">
                  {{ item.raw.key }}
                </span>
                <span v-else> {{ $t("constants." + item.value.name) }}</span>
              </v-chip>
            </template>
          </v-select>
        </v-col>

        <!-- <v-col cols="auto" class="pl-0">
          <ThemePickerVue />
        </v-col> -->

        <!-- <v-col cols="auto" class="px-4 hoverable" style="display: flex; align-items: center;
            align-content: center; position: relative;" @click="()=>{this.refreshDisplay++}"  v-if="showCart && !isNative">
          <div style=" position: relative;">
          <v-icon class="headerNav">mdi-cart</v-icon>
          <div v-if="activeCart"
            style="position: absolute; top: -5px; right: -5px; height: 10px; width: 10px; background-color: rgba(var(--v-theme-primary)); border-radius: 50%;">
          </div>
            </div>
        </v-col> -->

        <v-col cols="auto" style="display: flex; align-items: center" v-if="!isMobile">
          <p>{{ $t("basics.hello") }}, {{ username }}!</p>
        </v-col>
        <v-col v-if="!isMobile" cols="auto" style="display: flex; align-items: center">
          <v-tooltip :text="$t('basics.logout')">
            <template v-slot:activator="{ props }">
              <p class="hoverable" v-bind="props" @click="logout()">
                <b><v-icon>mdi-logout</v-icon></b>
              </p>
            </template>
          </v-tooltip>
        </v-col>

        <v-col v-if="isMobile" cols="auto" style="display: flex; align-items: center">
          <MobileNavigationVue />
        </v-col>
      </v-row>
    </v-container>
  </v-app-bar>
  <shopping-cart :refreshDisplay="refreshDisplay" />
</template>

<script>
// import ThemePickerVue from "../main/ThemePicker.vue";
import BreadcrumbsVue from "./Breadcrumbs.vue";
import MobileNavigationVue from "./MobileNavigation.vue";
import ShoppingCart from "../shop/ShoppingCart.vue";
import { Capacitor } from "@capacitor/core";

export default {
  name: "headerComponent",

  data() {
    return {
      roles: [],
      role: [],
      refreshDisplay: 0,
    };
  },

  components: {
    BreadcrumbsVue,
    // ThemePickerVue,
    MobileNavigationVue,
    ShoppingCart,
  },

  computed: {
    isDarkTheme() {
      return this.$vuetify.theme.global.current.dark;
    },
    username() {
      return this.$store.state.name;
    },
    activeCart(){
      return this.$store.state.shopping_cart_items && this.$store.state.shopping_cart_items.length > 0;
    },
    isMobile() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return true;
        case "sm":
          return true;
        case "md":
          return true;
        case "lg":
          return false;
        case "xl":
          return false;
        case "xxl":
          return false;
        default:
          return false;
      }
    },
    
    showCart(){
      return this.$route.path.includes("products") || this.activeCart
    },
    isIOS(){
      if(Capacitor.getPlatform() == 'ios'){
        return true
      } else {
        return false
      }
    },
    isNative(){
      if(Capacitor.isNativePlatform()){
        return true
      } else {
        return false
      }
    },

  },

  methods: {
    addRole(role) {
      let found = false;

      for (let i = 0; i < this.role.length; i++) {
        if (this.role[i].key == role.raw.key) {
          this.role.splice(i, 1);
          found = true;
          break;
        }
      }

      if (!found) {
        this.role.push(role.raw);
      }

      this.axios
        .patch(this.axios.defaults.baseURL + "user/role/patch/", {
          permission: JSON.stringify(this.role),
        })
        .then((resp) => {
          let temp = [];
          for (let i = 0; i < this.role.length; i++) {
            temp.push(this.role[i].name);
          }
          this.$store.dispatch("setPermission", temp.toString());

          temp = this.$store.state.avail_routes.split(",");
          this.$router.push("/" + temp[0] + "/dashboard");

          this.$refs.roleChanger.blur();
          this.fetchPermissions();
        })
        .catch((e) => {
          console.log(e);
          window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
        });
    },
    logout() {
      this.$store.dispatch("logoutUser").catch((e) => {
        window.location.reload();
      });
    },
    gotoDashboard() {
      if(Capacitor.isNativePlatform()){
        let temp = this.$store.state.avail_routes.split(",");
        this.$router.push("/" + temp[0] + "/dashboard");
        } else {
        this.$router.push("/");        
      }
    },
    roleIsSelected(role) {
      for (let i = 0; i < this.role.length; i++) {
        if (this.role[i].key == role.raw.key) {
          return true;
        }
      }

      return false;
    },
    fetchRoles() {
      setTimeout(() => {
        this.axios.get(this.axios.defaults.baseURL + "user/roles/").then((resp) => {
          this.roles = resp.data;
          this.role = [];

          let permissions;
          if (typeof this.$store.state.permission == "string") {
            permissions = this.$store.state.permission.split(",");
          } else {
            permissions = this.$store.state.permission;
          }

          for (let i = 0; i < this.roles.length; i++) {
            for (let j = 0; j < permissions.length; j++) {
              if (permissions[j] == this.roles[i].name) {
                this.role.push(this.roles[i]);
              }
            }
          }

          this.fetchPermissions();
        });
      }, 500);
    },

    fetchPermissions() {
      this.axios.get(this.axios.defaults.baseURL + "permissions/").then((resp) => {
        this.$store.dispatch("setRouterPermission", resp.data);

        // this.fetchTraegers();
      });
    },
    fetchTraegers() {
      setTimeout(() => {
        this.axios
          .get(this.axios.defaults.baseURL + "user/users/traegers/")
          .then((resp) => {
            this.$store.dispatch("setTraegers", resp.data);
          });
      }, 500);
    },
  },

  mounted() {
    if (this.$store.state.staff) {
      this.fetchRoles();
    } else {
      setTimeout(()=>{
        this.fetchPermissions();
      }, 500)
    }
  },
};
</script>
